export const NUMBER_REGEX = /^[0-9]*$/;
export const NAME_REGEX = /^[\w\-_(),.\s]*$/;
export const PHONE_NUM = /^[0-9]{8,14}$/;
export const PHONE_NUM_CODE =  /^\+[0-9]{8,14}$/;
export const POST_CODE = /^[0-9]{8}$/;
export const ALPHANUM_SPACE_REGEX = /^([ ]{0,1}[a-zA-Z0-9]+[ ]{0})*$/;
export const ALPHANUM_REGEX = /^[a-zA-Z0-9]+$/;
export const ALPHA_ONE_SPACE_REGEX = /^[a-zA-Z]+(?: [a-zA-Z]+)*$/;
export const ALPHA_ONE_SPACE_AT_COMA_REGEX = /^[a-zA-Z@.-]+(?: [a-zA-Z@.-]+)*$/;
export const ALPHA_NUM_SPACE_COMA_REGEX=/^([a-zA-Z0-9,]+[ ]{0,1})*$/;
export const ALPHA_NUM_HYPHEN_REGEX = /^[a-zA-Z0-9-]+$/;
export const EMAIL = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/; 
export const DECIMAL_NUMBER=/^\d+(\.\d{1,2})?$/;
export const PHONE_USA =  /^\+?1?\d{3}-?\d{3}-?\d{4}$/;
export const DATE_REGEX =  /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/;
export const DOLLAR_DECIMAL_NUMBER=/^\$\s?\d+(\.\d{1,2})?$/;
export const URL_VALIDATION=/^(ftp|http|https):\/\/[^ "]+$/;
export const CONTACT_NUM = /^\d{3}-\d{3}-\d{4}$/;
